import { apiUrls } from '../api/api-urls'
import { fetchMutation } from '../utils'
import { RecommendationData } from './recommendation-page'

export const getRecommendations = (platform: string) =>
  fetchMutation<RecommendationData>(`${apiUrls.recommendations}/${platform}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }, true)
